import { cn } from "@/utils"

export const CardStatus = ({ status, onClick, className }: { status: string; className?: string; onClick?: () => void }) => {
  const statusClass = status.replace(" ", "_").toLowerCase()
  return (
    <div onClick={onClick} className={cn("card_status_label", className, statusClass)}>
      {status}
    </div>
  )
}
